export const SELECT_SITE = 'selected.SELECT_SITE';
export const UNSELECT_SITE = 'selected.UNSELECT_SITE';

